'use client';

import { cn } from '@bazaar-marketplace/utils';

interface Step {
  stepNumber: number;
  description: string;
  label?: string;
}

interface StepListProps {
  steps: Step[];
  className?: string;
}

export const StepList = ({ steps, className }: StepListProps) => (
  <div className={cn('flex flex-col gap-2', className)}>
    {steps.map((step) => (
      <div
        key={step.stepNumber}
        className="flex p-3 gap-4 border border-white/20 rounded-[24px] items-center bg-white/10"
      >
        <div className="size-[40px] border border-white/20 shrink-0 rounded-full flex items-center justify-center bg-white/10">
          <span className="text-white/60 text-[16px] font-bold">{step.label ?? step.stepNumber}</span>
        </div>
        <div className="flex flex-col justify-center">
          <span className="font-bold text-white/60 text-sm text-[14px]">{step.description}</span>
        </div>
      </div>
    ))}
  </div>
);
